import React from "react";
import { FaSearch, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "./Navbar.css";
import logo from "../images/logo.png";
import { useSearch } from "../SearchContext";
import MinNavbar from "./MinNavbar";

const Navbar = () => {
  const { searchTerm, setSearchTerm } = useSearch();
  return (
    <div className="top-navbar d-flex justify-content-between align-items-center px-4 py-1">
      {/* Logo */}
      <div className="logo fw-bold fs-4 text-success">
        <img
          src={logo}
          alt="Logo"
          className="logo-img me-0"
          style={{ height: "60px" }}
        />{" "}
        <span className="logo-txt">
          Uzhavan SuperMarket🍃
        </span>
      </div>

      {/* Search bar */}
      <div className="search-bar d-flex align-items-center">
        <input
          type="text"
          placeholder="Search our store"
          className="form-control"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
        />
        <button className="btn btn-success text-dark">
          <FaSearch />
        </button>
      </div>

      {/* Contact info */}
      <div className="contact-info  sm-3 m-0 p-0 gap-0">

        <div className=" d-flex align-items-center justify-content-start d-md-none nav-flex">
          <MinNavbar />
        </div>

        <div className=" d-flex align-items-center justify-content-start">
          <div className="icon-circle">
            <FaPhoneAlt />
          </div>
          <div className="ms-2 text-muted">+91-7904235014</div>
        </div>

        <div className=" d-flex align-items-center justify-content-start">
          <div className="icon-circle">
            <FaEnvelope />
          </div>
          <div className="ms-2 text-muted">uzhavan@gmail.com</div>
        </div>
        
      </div>
    </div>
  );
};

export default Navbar;
